webpackJsonp([4],{

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(301);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46560dc3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(344);
var normalizeComponent = __webpack_require__(89)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46560dc3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    authUserDetails: function authUserDetails() {
      return this.$store.getters.user;
    },
    shoppingCart: function shoppingCart() {
      return this.$store.getters.shoppingCart;
    },
    Total: function Total() {
      var total = 0;
      this.$store.getters.shoppingCart.forEach(function (item) {
        total += item.productPrice * item.qty;
      });
      return total;
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    removeItem: function removeItem(payload) {
      this.$store.dispatch('REMOVE_ITEM', payload);
    },
    saveShoppingCart: function saveShoppingCart(authUserDetails) {
      this.$store.dispatch('SAVE_SHOPPING_CART', authUserDetails);
    },
    placeOrder: function placeOrder(payload) {
      this.$store.dispatch('PLACE_ORDER', payload);
    }
  },
  mounted: function mounted() {
    this.saveShoppingCart();
  }
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticStyle:{"font-size":"48px"}},[_vm._v("Votre Panier")])]),_vm._v(" "),_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":""}},[_vm._l((_vm.shoppingCart),function(item,index){return _c('v-layout',{key:index,staticClass:"pb-2",staticStyle:{"border-bottom":"2px solid grey"},attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-card',{staticStyle:{"border-radius":"10px"}},[_c('v-card-media',{attrs:{"src":item.productImg,"height":"150px"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md4":""}},[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(item.productName))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center pt-4",attrs:{"xs12":"","md1":""}},[_c('v-text-field',{attrs:{"solo":"","type":"number","color":"primary"},model:{value:(item.qty),callback:function ($$v) {_vm.$set(item, "qty", $$v)},expression:"item.qty"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md2":""}},[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm._f("currency")(item.productPrice * item.qty)))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md2":""}},[_c('v-btn',{staticClass:"primary",attrs:{"icon":"","dark":"","large":""},on:{"click":function($event){_vm.removeItem(item)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)}),_vm._v(" "),_c('v-layout',{staticClass:"pb-2",staticStyle:{"border-bottom":"2px solid grey"},attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-btn',{staticClass:"primary",attrs:{"medium":"","dark":""},on:{"click":function($event){_vm.saveShoppingCart(_vm.authUserDetails.id)}}},[_c('b',[_vm._v("Enregistrer le panier")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md4":""}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md1":""}},[_c('span',{staticStyle:{"font-size":"36px"}},[_vm._v("Total")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md2":""}},[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.Total)))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md2":""}},[_c('v-btn',{staticClass:"success",attrs:{"medium":"","dark":""},on:{"click":function($event){_vm.placeOrder(_vm.Total)}}},[_c('b',[_vm._v("Confirmer")]),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.89d4fe1f84530ce3026a.js